__webpack_require__.p = "https://mira-now-staging.scalable.care/";